import { api } from '@/lib/api'
import type { DownloadUrl, FileAttachment, UpdateFileMetadataRequest } from './types'

const base = (contractId: number) => `/api/contracts/${contractId}/files`

export async function listFiles(contractId: number): Promise<FileAttachment[]> {
  const r = await api.get<FileAttachment[]>(base(contractId))
  return r.data
}

export async function uploadFile(
  contractId: number,
  file: File,
  options: { documentTypeId?: number | null; description?: string | null } = {},
): Promise<FileAttachment> {
  const form = new FormData()
  form.append('file', file)
  if (options.documentTypeId != null) form.append('documentTypeId', String(options.documentTypeId))
  if (options.description) form.append('description', options.description)
  // Timeout, zeby zerwane/wiszace polaczenie nie zostawialo loadera krecacego sie
  // w nieskonczonosc - po przekroczeniu axios przerywa (ECONNABORTED) i leci onError.
  const r = await api.post<FileAttachment>(base(contractId), form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120_000,
  })
  return r.data
}

export async function getDownloadUrl(contractId: number, fileId: number): Promise<DownloadUrl> {
  const r = await api.get<DownloadUrl>(`${base(contractId)}/${fileId}/download-url`)
  return r.data
}

export async function getThumbnailUrl(
  contractId: number,
  fileId: number,
  width: number,
): Promise<DownloadUrl> {
  const r = await api.get<DownloadUrl>(`${base(contractId)}/${fileId}/thumbnail-url`, {
    params: { w: width },
  })
  return r.data
}

export async function deleteFile(contractId: number, fileId: number): Promise<void> {
  await api.delete(`${base(contractId)}/${fileId}`)
}

export async function updateMetadata(
  contractId: number,
  fileId: number,
  payload: UpdateFileMetadataRequest,
): Promise<void> {
  await api.patch(`${base(contractId)}/${fileId}`, payload)
}
